// ===================================================================
// 🔐 MODAL MEUS DADOS - Proprietário (alterar login e senha)
// ===================================================================

import React, { useState, useCallback } from 'react';
import { styles } from '../../styles/globalStyles';
import { Modal } from '../ui/Modal';
import { Alert } from '../ui/Alert';
import { apiClient } from '../../api/apiClient';
import { validateNewPassword, PASSWORD_POLICY_HINT } from '../../utils/passwordPolicy';

export const MasterProfileModal = React.memo(({ user, onClose, onUserUpdate }) => {
  const [email, setEmail] = useState(user?.email || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    const emailTrim = (email || '').trim();
    if (!emailTrim) {
      setError('Email é obrigatório');
      return;
    }
    if (password) {
      const pwdErr = validateNewPassword(password);
      if (pwdErr) {
        setError(pwdErr);
        return;
      }
    }
    if (password && password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    setSaving(true);
    try {
      const payload = { email: emailTrim };
      if (password) payload.password = password;
      const { data, error: err } = await apiClient.auth.updateMe(payload);
      if (err) {
        setError(err);
      } else if (data?.user) {
        onUserUpdate?.(data.user);
        onClose?.();
      }
    } catch (err) {
      setError(err.message || 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  }, [email, password, confirmPassword, onClose, onUserUpdate]);

  return (
    <Modal isOpen onClose={onClose} title="Meus dados - Alterar login e senha">
      <form onSubmit={handleSubmit} style={styles.form}>
        {error && <Alert type="error" message={error} onClose={() => setError('')} />}
        <div style={{ marginBottom: '16px' }}>
          <label style={styles.label}>Email (login)</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            placeholder="seu@email.com"
            required
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={styles.label}>Nova senha (deixe em branco para não alterar)</label>
          <p style={{ fontSize: 12, color: '#6B7280', margin: '0 0 8px', lineHeight: 1.5 }}>{PASSWORD_POLICY_HINT}</p>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            placeholder="Mínimo 8 caracteres"
            minLength={8}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={styles.label}>Confirmar nova senha</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={styles.input}
            placeholder="Repita a senha"
          />
        </div>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} style={{ ...styles.button, ...styles.buttonSecondary }}>
            Cancelar
          </button>
          <button type="submit" disabled={saving} style={{ ...styles.button, ...styles.buttonPrimary, opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
});
